import { Component, computed } from "@angular/core"
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router"
import { toSignal } from "@angular/core/rxjs-interop"
import { filter, map } from "rxjs"
import { HeaderComponent } from "../../components/header/header.component"

export type BenefitView = "table" | "add" | "edit"

@Component({
    selector: "valben-benefit-layout",
    standalone: true,
    imports: [RouterOutlet, HeaderComponent],
    template: `
        <valben-header
            [contentType]="contentType()"
            [editEnabled]="view() === 'edit'"
            [basePath]="basePath"
        ></valben-header>
        <router-outlet></router-outlet>
    `,
    styles: [`
        :host {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    `],
})
export class BenefitLayoutPage {
    view = toSignal(
        this._router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            map(() => this._currentView())
        ),
        { initialValue: this._currentView() }
    )

    contentType = computed(() => (this.view() === "add" ? 1 : this.view() === "edit" ? 2 : 0))

    /** Section root ("/awards", "/categories", ...). The header navigates off this itself. */
    basePath: string

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
    ) {
        this.basePath = "/" + this._route.snapshot.pathFromRoot.flatMap(r => r.url.map(s => s.path)).join("/")
    }

    private _currentView(): BenefitView {
        return (this._route.snapshot.firstChild?.data?.["view"] ?? "table") as BenefitView
    }
}
